import { 
  FaReact, 
  FaNodeJs, 
  FaJs, 
  FaHtml5, 
  FaGitAlt, 
  FaPython, 
  FaAngular,
  FaDocker,
  FaCode,
  FaLanguage,
  FaLinux,
  FaAndroid,
  FaWindows,
  FaShieldAlt,
  FaUserSecret,
  FaNetworkWired,
  FaRobot,
  FaServer,
  FaChartBar
} from 'react-icons/fa';
import { 
  SiExpress,
  SiFlask,
  SiPostgresql,
  SiMysql,
  SiSequelize,
  SiSqlalchemy,
} from 'react-icons/si';
import { VscAzure } from 'react-icons/vsc';
import { MdSecurity, MdArchitecture } from 'react-icons/md';
import { BsFileEarmarkExcel, BsFileEarmarkWord, BsFileEarmarkPpt, BsLayers } from 'react-icons/bs';
import { HiOutlineMail } from 'react-icons/hi';
import { VscCode } from 'react-icons/vsc';

export const skillsData = [
  // Backend
  {
    id: 1,
    name: 'Python',
    icon: <FaPython />,
    level: 95,
    color: '#00d4ff',
    category: 'backend'
  },
  {
    id: 2,
    name: 'Node.js',
    icon: <FaNodeJs />,
    level: 90,
    color: '#7c3aed',
    category: 'backend'
  },
  {
    id: 3,
    name: 'Express.js',
    icon: <SiExpress />,
    level: 88,
    color: '#00d4ff',
    category: 'backend'
  },
  {
    id: 4,
    name: 'Flask',
    icon: <SiFlask />,
    level: 85,
    color: '#7c3aed',
    category: 'backend'
  },
  // Frontend
  {
    id: 5,
    name: 'JavaScript',
    icon: <FaJs />,
    level: 95,
    color: '#00d4ff',
    category: 'frontend'
  },
  {
    id: 6,
    name: 'HTML5/CSS3',
    icon: <FaHtml5 />,
    level: 95,
    color: '#7c3aed',
    category: 'frontend'
  },
  {
    id: 7,
    name: 'React',
    icon: <FaReact />,
    level: 90,
    color: '#00d4ff',
    category: 'frontend'
  },
  {
    id: 8,
    name: 'Angular',
    icon: <FaAngular />,
    level: 85,
    color: '#7c3aed',
    category: 'frontend'
  },
  // Database & Tools
  {
    id: 9,
    name: 'MySQL / PostgreSQL',
    icon: <SiMysql />,
    level: 90,
    color: '#00d4ff',
    category: 'database'
  },
  {
    id: 10,
    name: 'SQLAlchemy',
    icon: <SiSqlalchemy />,
    level: 85,
    color: '#7c3aed',
    category: 'database'
  },
  {
    id: 11,
    name: 'Sequelize',
    icon: <SiSequelize />,
    level: 80,
    color: '#00d4ff',
    category: 'database'
  },
  {
    id: 12,
    name: 'Git/GitHub',
    icon: <FaGitAlt />,
    level: 90,
    color: '#7c3aed',
    category: 'database'
  },
  {
    id: 13,
    name: 'Cybersecurity',
    icon: <MdSecurity />,
    level: 80,
    color: '#00d4ff',
    category: 'os_security'
  },
  {
    id: 14,
    name: 'Docker',
    icon: <FaDocker />,
    level: 75,
    color: '#7c3aed',
    category: 'database'
  },
  // Office
  {
    id: 15,
    name: 'Microsoft Excel',
    icon: <BsFileEarmarkExcel />,
    level: 95,
    color: '#00d4ff',
    category: 'office'
  },
  {
    id: 16,
    name: 'Microsoft Word',
    icon: <BsFileEarmarkWord />,
    level: 90,
    color: '#7c3aed',
    category: 'office'
  },
  {
    id: 17,
    name: 'Microsoft PowerPoint',
    icon: <BsFileEarmarkPpt />,
    level: 88,
    color: '#00d4ff',
    category: 'office'
  },
  {
    id: 18,
    name: 'Microsoft Outlook',
    icon: <HiOutlineMail />,
    level: 85,
    color: '#7c3aed',
    category: 'office'
  },
  {
    id: 19,
    name: 'Power BI',
    icon: <FaChartBar />,
    level: 78,
    color: '#00d4ff',
    category: 'office'
  },
  {
    id: 20,
    name: 'ERP Systems',
    icon: <FaServer />,
    level: 80,
    color: '#7c3aed',
    category: 'office'
  },
  // Sistemas Operacionais & Segurança
  {
    id: 30,
    name: 'Segurança de Rede',
    icon: <FaNetworkWired />,
    level: 80,
    color: '#00d4ff',
    category: 'os_security'
  },
  {
    id: 31,
    name: 'Pentesting',
    icon: <FaUserSecret />,
    level: 70,
    color: '#7c3aed',
    category: 'os_security'
  },
  {
    id: 32,
    name: 'Windows',
    icon: <FaWindows />,
    level: 85,
    color: '#00d4ff',
    category: 'os_security'
  },
  {
    id: 33,
    name: 'Linux',
    icon: <FaLinux />,
    level: 80,
    color: '#7c3aed',
    category: 'os_security'
  },
  {
    id: 34,
    name: 'Android',
    icon: <FaAndroid />,
    level: 75,
    color: '#00d4ff',
    category: 'os_security'
  }
];

export const skillCategories = [
  { id: 'backend', label: 'Backend' },
  { id: 'frontend', label: 'Frontend' },
  { id: 'database', label: 'Database & Tools' },
  { id: 'os_security', label: 'Sistemas Operacionais & Segurança' },
  { id: 'office', label: 'Office' }
];

// Dados separados para o card adicional
export const additionalSkillsData = [
  // Arquitetura de Software
  {
    id: 19,
    name: 'MVC',
    icon: <BsLayers />,
    level: 90,
    color: '#00d4ff',
    category: 'architecture'
  },
  {
    id: 20,
    name: 'DDD',
    icon: <MdArchitecture />,
    level: 85,
    color: '#7c3aed',
    category: 'architecture'
  },
  {
    id: 21,
    name: 'Clean Code',
    icon: <VscCode />,
    level: 88,
    color: '#00d4ff',
    category: 'architecture'
  },
  // Soluções Especializadas
  {
    id: 25,
    name: 'Gerenciamento de Servidor Linux',
    icon: <FaServer />,
    level: 80,
    color: '#00d4ff',
    category: 'solutions'
  },
  {
    id: 26,
    name: 'Desenvolvimento de bots/mods/plugins',
    icon: <FaRobot />,
    level: 75,
    color: '#7c3aed',
    category: 'solutions'
  },
  {
    id: 27,
    name: 'Gerenciamento de banco de dados',
    icon: <SiPostgresql />,
    level: 80,
    color: '#00d4ff',
    category: 'solutions'
  },
  {
    id: 28,
    name: 'Desenvolvimento e Manutenção de Sites',
    icon: <FaCode />,
    level: 85,
    color: '#7c3aed',
    category: 'solutions'
  },
  // Idiomas
  {
    id: 22,
    name: 'Português',
    icon: <FaLanguage />,
    level: 100,
    color: '#00d4ff',
    category: 'languages'
  },
  {
    id: 23,
    name: 'Inglês',
    icon: <FaLanguage />,
    level: 75,
    color: '#7c3aed',
    category: 'languages'
  },
  {
    id: 24,
    name: 'Espanhol',
    icon: <FaLanguage />,
    level: 70,
    color: '#00d4ff',
    category: 'languages'
  }
];

export const additionalSkillCategories = [
  { id: 'architecture', label: 'Arquitetura de Software' },
  { id: 'solutions', label: 'Soluções Especializadas' },
  { id: 'languages', label: 'Idiomas' }
];

export const getAdditionalSkillsByCategory = (category) => {
  return additionalSkillsData.filter(skill => skill.category === category);
};

export const getSkillsByCategory = (category) => {
  return skillsData.filter(skill => skill.category === category);
};